// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner_EFcSt-ub .message{overflow:hidden}.banner_EFcSt-ub .message-enter{height:0px;opacity:0}.banner_EFcSt-ub .message-enter.message-enter-active{height:40px;opacity:1;transition:height,opacity 200ms ease-in}.banner_EFcSt-ub .message-leave{height:40px;opacity:1}.banner_EFcSt-ub .message-leave.message-leave-active{height:0px;opacity:0;transition:height,opacity 200ms ease-in}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": "banner_EFcSt-ub"
};
export default ___CSS_LOADER_EXPORT___;
